// extracted by mini-css-extract-plugin
module.exports = {"DownArrowAnimation":"DownArrowAnimation_DownArrowAnimation__UWiEz","iconContainer":"DownArrowAnimation_iconContainer__iD7Jn","icon":"DownArrowAnimation_icon__gLtti"};